import React from 'react';

// Who makes the site, and whose game Sequence is. Shown at the foot of every
// page and the game screens, so it's worded once here.

export const COMPANY = 'Tedora Technologies';
export const COMPANY_URL = 'https://www.tedoratech.com';
export const CONTACT_EMAIL = 'admin@tedoratech.com';

const link = { color: 'inherit', textDecoration: 'underline', textUnderlineOffset: 2 };

const Credits = () => (
    <>
        Play Sequence is developed by{' '}
        <a href={COMPANY_URL} target="_blank" rel="noopener noreferrer" style={link}>{COMPANY}</a>
        {' · '}
        <a href={`mailto:${CONTACT_EMAIL}`} style={link}>{CONTACT_EMAIL}</a>
        <br />
        &copy; {new Date().getFullYear()} {COMPANY}. SEQUENCE&reg; is a registered trademark of Jax Ltd., Inc.,
        a Goliath Games company. Play Sequence is an independent site and is not affiliated with or endorsed by
        Jax Ltd., Inc. or Goliath Games.
    </>
);

export default Credits;
